import React from 'react';
import Hero from './Hero';
import Header from '../Header';
import Categories from './Categories';
const Home = () => {
    return (
        <>
        <Header />
        <Hero />
        <Categories />
        </>
    )
}
export default Home;